<!--新闻/资讯详情-->
<template class="carbon">
  <div style="font-family: Alibaba">
    <!--CP端-->
    <div class="PC_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component class="act" :is='components.tail'></component>
        </keep-alive>
      </div>

      <!--导航图-->
      <div style="margin-bottom:80px">
        <el-carousel height="25vw" class='carousel_class'>
          <el-carousel-item v-for='item in carouselList' :key='item.id'>
            <div @click='jump(item)'>
              <el-image
                style="width: 100%;height: 25vw"
                v-if='item.imageUrl != null'
                :src='item.imageUrl'
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <!--新闻-->
      <div class="box-width newContent">
        <h4>完善碳价机制与政策保障 加速碳交易市场发展</h4>
        <p>2024-02-28 16:20:15</p>
        <span>
          近年来，我国在碳排放交易试点方面取得了显著成果。在节能减排的大趋势之下，未来我国的碳市场交易规模将高达4000亿元。然而要促进我国碳交易市场快速发展，在行业各方的努力同时，
          更需要制度和法律的保障。随着全球对地球变暖”担忧的加剧，气候变化已经成为人类未来生存和发展必须面对的问题。我国政府一直为应对气候变化作着积极的努力，2015年12月，中国在巴
          黎气候大会上庄严宣布，将在2017年全面启动碳排放权交易市场。“加快转变经济发展模式，解决突出的资源环境问题，积极应对气候变化，必须高度重视低碳发展。”在日前举行的2016中国
          碳交易市场发展论坛上，国家环保总局原副局长、十一届全国政协人口资源环境委员会副主任王玉庆表示。但聚光灯下，困境依然待解。现阶段，我国许多高耗能企业在技术路线、工艺水平等
          方面同质化现象严重，这就导致了企业在能源消耗和碳排放上相差无几，碳排放基准值定得过高或过低，都将直接影响碳交易市场的活跃程度。北京神雾集团董事局主席吴道洪建议，除即将推
          出的全国碳交易市场的制度、政策以及操作程序外，还应该有直接激发和鼓励广大节能、低碳创新企业发展的政策出台。全球最具潜力的碳交易市场近年来，我国在碳排放交易试点方面取得了
          显著成果。2011年10月，国家发展改革委批准了北京、天津、上海、湖北等7个碳排放权交易试点，并将2013—2015年定为试点阶段。截至目前，湖北碳排放权交易中心已经成为了继欧洲、
          广东之后的全球第三大碳交易市场，各项交易数据均居全国首位。在节能减排的大趋势之下，我国制造业低碳发展存在着巨大的空间。因此，我国也被看作是全球最具潜力的碳交易市场。据预
          测，未来我国碳市场的交易量将在30亿~40亿吨/年，现货交易额最高有望达到80亿元/年，实现碳期货交易后，全国碳市场交易规模将高达4000亿元。
          近年来，我国在碳排放交易试点方面取得了显著成果。在节能减排的大趋势之下，未来我国的碳市场交易规模将高达4000亿元。然而要促进我国碳交易市场快速发展，在行业各方的努力同时，
          更需要制度和法律的保障。随着全球对地球变暖”担忧的加剧，气候变化已经成为人类未来生存和发展必须面对的问题。我国政府一直为应对气候变化作着积极的努力，2015年12月，中国在巴
          黎气候大会上庄严宣布，将在2017年全面启动碳排放权交易市场。“加快转变经济发展模式，解决突出的资源环境问题，积极应对气候变化，必须高度重视低碳发展。”在日前举行的2016中国
          碳交易市场发展论坛上，国家环保总局原副局长、十一届全国政协人口资源环境委员会副主任王玉庆表示。但聚光灯下，困境依然待解。现阶段，我国许多高耗能企业在技术路线、工艺水平等
          方面同质化现象严重，这就导致了企业在能源消耗和碳排放上相差无几，碳排放基准值定得过高或过低，都将直接影响碳交易市场的活跃程度。北京神雾集团董事局主席吴道洪建议，除即将推
          出的全国碳交易市场的制度、政策以及操作程序外，还应该有直接激发和鼓励广大节能、低碳创新企业发展的政策出台。全球最具潜力的碳交易市场近年来，我国在碳排放交易试点方面取得了
          显著成果。2011年10月，国家发展改革委批准了北京、天津、上海、湖北等7个碳排放权交易试点，并将2013—2015年定为试点阶段。截至目前，湖北碳排放权交易中心已经成为了继欧洲、
          广东之后的全球第三大碳交易市场，各项交易数据均居全国首位。在节能减排的大趋势之下，我国制造业低碳发展存在着巨大的空间。因此，我国也被看作是全球最具潜力的碳交易市场。据预
          测，未来我国碳市场的交易量将在30亿~40亿吨/年，现货交易额最高有望达到80亿元/年，实现碳期货交易后，全国碳市场交易规模将高达4000亿元。
        </span>
      </div>
      <el-row  :gutter="20" class="box-width new_a">
        <el-col :lg="12" :md="12" :sm="12" :xs="24">
          <a href="/details">
            <div class="video_title">
              <h5>上一篇：完善碳价机制与政策保障 加速碳交易市场发展</h5>
            </div>
          </a>
        </el-col>
        <el-col :lg="12" :md="12" :sm="12" :xs="24">
          <a href="/details">
            <div class="video_title">
              <h5>下一篇：环保在线 | 聚焦智慧环保 推动高新技术在低碳能源中应用</h5>
            </div>
          </a>
        </el-col>
      </el-row>

      <!--内容推荐标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>内容推荐
          </h1>
          <p>Content Recommendation</p>
        </div>
      </div>

      <!--内容推荐列表-->
      <el-card class="box-width news" shadow="hover" style="margin-bottom: 10px !important;"  :key="o" v-for="o in 5">
        <div class="text_item">
          <h4>央视报道《朝闻天下》| 保证碳排放数据质量 对弄虚作假“零容忍”</h4>
          <p>2024-02-28 16:20:15</p>
          <span class="text">生态环境部相关负责人表示，数据质量是碳市场的生命线，即将施行的《碳排放权交易管理暂行条例》中已明确各有关部门的监管职责，将对碳排放数据弄虚作假的行为“零容忍”，严惩重罚，公开曝光相关的违法违规行为。</span>
          <div>
            <el-link :underline="false"  href="/details" target="_blank" style="font-size: 12px">了解更多...</el-link>
          </div>

        </div>
      </el-card>
      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box product">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class='paddingS'>
        <!--占位div-->
        <div style='height: 72px'></div>

        <!--新闻-->
        <div style="margin-bottom: 10px">
          <el-card class="box-width new_Content" shadow="hover">
            <h4>完善碳价机制与政策保障 加速碳交易市场发展</h4>
            <p>2024-02-28 16:20:15</p>
            <span>
          近年来，我国在碳排放交易试点方面取得了显著成果。在节能减排的大趋势之下，未来我国的碳市场交易规模将高达4000亿元。然而要促进我国碳交易市场快速发展，在行业各方的努力同时，
          更需要制度和法律的保障。随着全球对地球变暖”担忧的加剧，气候变化已经成为人类未来生存和发展必须面对的问题。我国政府一直为应对气候变化作着积极的努力，2015年12月，中国在巴
          黎气候大会上庄严宣布，将在2017年全面启动碳排放权交易市场。“加快转变经济发展模式，解决突出的资源环境问题，积极应对气候变化，必须高度重视低碳发展。”在日前举行的2016中国
          碳交易市场发展论坛上，国家环保总局原副局长、十一届全国政协人口资源环境委员会副主任王玉庆表示。但聚光灯下，困境依然待解。现阶段，我国许多高耗能企业在技术路线、工艺水平等
          方面同质化现象严重，这就导致了企业在能源消耗和碳排放上相差无几，碳排放基准值定得过高或过低，都将直接影响碳交易市场的活跃程度。北京神雾集团董事局主席吴道洪建议，除即将推
          出的全国碳交易市场的制度、政策以及操作程序外，还应该有直接激发和鼓励广大节能、低碳创新企业发展的政策出台。全球最具潜力的碳交易市场近年来，我国在碳排放交易试点方面取得了
          显著成果。2011年10月，国家发展改革委批准了北京、天津、上海、湖北等7个碳排放权交易试点，并将2013—2015年定为试点阶段。截至目前，湖北碳排放权交易中心已经成为了继欧洲、
          广东之后的全球第三大碳交易市场，各项交易数据均居全国首位。在节能减排的大趋势之下，我国制造业低碳发展存在着巨大的空间。因此，我国也被看作是全球最具潜力的碳交易市场。据预
          测，未来我国碳市场的交易量将在30亿~40亿吨/年，现货交易额最高有望达到80亿元/年，实现碳期货交易后，全国碳市场交易规模将高达4000亿元。
          近年来，我国在碳排放交易试点方面取得了显著成果。在节能减排的大趋势之下，未来我国的碳市场交易规模将高达4000亿元。然而要促进我国碳交易市场快速发展，在行业各方的努力同时，
          更需要制度和法律的保障。随着全球对地球变暖”担忧的加剧，气候变化已经成为人类未来生存和发展必须面对的问题。我国政府一直为应对气候变化作着积极的努力，2015年12月，中国在巴
          黎气候大会上庄严宣布，将在2017年全面启动碳排放权交易市场。“加快转变经济发展模式，解决突出的资源环境问题，积极应对气候变化，必须高度重视低碳发展。”在日前举行的2016中国
          碳交易市场发展论坛上，国家环保总局原副局长、十一届全国政协人口资源环境委员会副主任王玉庆表示。但聚光灯下，困境依然待解。现阶段，我国许多高耗能企业在技术路线、工艺水平等
          方面同质化现象严重，这就导致了企业在能源消耗和碳排放上相差无几，碳排放基准值定得过高或过低，都将直接影响碳交易市场的活跃程度。北京神雾集团董事局主席吴道洪建议，除即将推
          出的全国碳交易市场的制度、政策以及操作程序外，还应该有直接激发和鼓励广大节能、低碳创新企业发展的政策出台。全球最具潜力的碳交易市场近年来，我国在碳排放交易试点方面取得了
          显著成果。2011年10月，国家发展改革委批准了北京、天津、上海、湖北等7个碳排放权交易试点，并将2013—2015年定为试点阶段。截至目前，湖北碳排放权交易中心已经成为了继欧洲、
          广东之后的全球第三大碳交易市场，各项交易数据均居全国首位。在节能减排的大趋势之下，我国制造业低碳发展存在着巨大的空间。因此，我国也被看作是全球最具潜力的碳交易市场。据预
          测，未来我国碳市场的交易量将在30亿~40亿吨/年，现货交易额最高有望达到80亿元/年，实现碳期货交易后，全国碳市场交易规模将高达4000亿元。
        </span>
          </el-card>
        </div>

        <!--新闻列表-->
        <el-card class="box-width news" shadow="hover" style="margin-bottom: 10px !important;"  :key="o" v-for="o in 3">
          <div class="text_item">
            <h4>央视报道《朝闻天下》| 保证碳排放数据质量 对弄虚作假“零容忍”</h4>
            <p>2024-02-28 16:20:15</p>
            <span class="text">生态环境部相关负责人表示，数据质量是碳市场的生命线，即将施行的《碳排放权交易管理暂行条例》中已明确各有关部门的监管职责，将对碳排放数据弄虚作假的行为“零容忍”，严惩重罚，公开曝光相关的违法违规行为。</span>
            <div>
              <el-link :underline="false" href="https://element.eleme.io" target="_blank" style="font-size: 12px">了解更多...</el-link>
            </div>
          </div>
        </el-card>
        <!--插入尾部-->
        <div>
          <keep-alive>
            <component  :is='components.tail1'></component>
          </keep-alive>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import header from '../components/header.vue'
import footer from '../components/footer.vue'

export default {
  data () {
    return {
      tabId: null,
      components: {
        tail: header,
        tail1: footer
      },
      form: {
        name: '',
        phone: '',
        company: '',
        demand: ''
      },
      player: null,
      options: {
        controls: true,
        poster: '',
        preload: 'auto'
        // 其他video.js选项...
      },
      activeName: 'second',
      fit: 'cover',
      url1: require('@assets/images/index/chanping1.png'),
      url: require('@assets/images/index/chanping.png'),
      url2: require('@assets/images/index/chanping2.png'),
      carouselList: [],
      carouselParams: {
        type: 1
      }
    }
  },
  created () {
    this.tabId = this.$route.query.tabId
    this.selectCarouselPicture(1)
  },
  mounted () {
  },
  beforeDestroy () {
    if (this.player) {
      this.player.dispose()
    }
  },
  methods: {
    jump (raw) {
      if (raw.newsId === undefined || raw.newsId === '' || raw.newsId === null) {
      } else {
        this.$router.push({
          path: '/textContent',
          query: {
            id: raw.newsId,
            type: 2
          }
        })
      }
    },
    /** 公司新闻滚动图 */
    selectCarouselPicture (raw) {
      let that = this
      that.carouselParams.type = raw
      // selectCarouselPicture(that.carouselParams).then(res => {
      //   res.forEach((value, index) => {
      //     value.imageUrl = that.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(value.imageUrl)
      //   })
      //   that.carouselList = res
      // })
      let img1 = {
        id: '1',
        imageUrl: require('@assets/images/heard/101.jpg')
      }
      that.carouselList.push(img1)
      let img2 = {
        id: '2',
        imageUrl: require('@assets/images/heard/102.jpg')
      }
      that.carouselList.push(img2)
      let img3 = {
        id: '3',
        imageUrl: require('@assets/images/heard/103.jpg')
      }
      that.carouselList.push(img3)
    },
    /** tab */
    handleClick (tab, event) {
      console.log(tab, event)
    },
    onSubmit () {
      console.log('submit!')
    }
  }
}
</script>
